export default {"src":"/_next/static/media/breakdown.81dda4b4.svg","height":32,"width":32};